import { ContainerApiSuccessResponse } from '../../containerApi.types'

// Keys are namespaced as `{app}:{flag}`, e.g. "external-forms:form-ai-studio".
// Only active flags are returned, and every value is a string ("true", "red").
export interface GetFeatureFlagsResponse
  extends ContainerApiSuccessResponse<Record<string, string>> {}

// "true"/"false" become booleans, any other value stays a string.
export type FeatureFlags = Record<string, boolean | string>
